import { ParametrosWSBase, DestinoConexion } from "../ParametrosWSBase";
import { EncabezadoRespuestaInterna } from "../EncabezadoRespuestaInterna";

export function ActivacionBlueToGoRest_Parametros(datos: any) {
  var par: ParametrosWSBase = {
    nombreProceso: "ActivacionBlueToGoRest",
    rutaEndPoint: "/EnterpriseServices/Sel/ActivacionBlueToGoRest",
    sistemaOrigen: "SEL",
    AGREGAR_ENCABEZADO: true,
    DESTINO_SERVICIO: DestinoConexion.Proxy,
    parametros: { ...datos },
        cRC:null
  };

  return par;
}

//ENTRADA
export interface ActivacionBlueToGoRest_Entrada {
    input: InputActivacion;
}

export function builtActivacionBlueToGoRestInput(p_input: InputActivacion ) {
    var retorno: ActivacionBlueToGoRest_Entrada ={input: p_input };
  
    return retorno;
}

export interface InputActivacion {
    CuentaSKY:              string;
    PaqueteSKY:             string;
    OTT:                    string;
    VEO:                    string;
    pasoBpel:               string;
    intento:                string;
    numeroSs:               string;
    idSesion:               string;
    producto:               string;
    enviaASiebel:           string;
    nombre_producto_siebel: string;
    fecha_fin_temporada:    string;
    origen:                 string;
}

export function builtInputActivacion(
    p_CuentaSKY:              string,
    p_PaqueteSKY:             string,
    p_OTT:                    string,
    p_VEO:                    string,
    p_pasoBpel:               string,
    p_intento:                string,
    p_numeroSs:               string,
    p_idSesion:               string,
    p_producto:               string,
    p_enviaASiebel:           string,
    p_nombre_producto_siebel: string,
    p_fecha_fin_temporada:    string,
    p_origen:                 string
) {
  var retorno: InputActivacion = {
    CuentaSKY:              p_CuentaSKY,
    PaqueteSKY:             p_PaqueteSKY,
    OTT:                    p_OTT,
    VEO:                    p_VEO,
    pasoBpel:               p_pasoBpel,
    intento:                p_intento,
    numeroSs:               p_numeroSs,
    idSesion:               p_idSesion,
    producto:               p_producto,
    enviaASiebel:           p_enviaASiebel,
    nombre_producto_siebel: p_nombre_producto_siebel,
    fecha_fin_temporada:    p_fecha_fin_temporada,
    origen:                 p_origen
  };

  return retorno;
}


//SALIDA
export interface ActivacionBlueToGoRest_Salida {
    result: Result;
}

export interface Result {
    respuesta:     string;
    respuestaCode: string;
}


export type ActivacionBlueToGoRest_Respuesta =ActivacionBlueToGoRest_Salida;
